(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/coupon-static-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/coupon-static-row.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useMemo,
  useEffect,
  useState,
  useCallback,
  useContext
} = React;
const {
  useSelector
} = ReactRedux;
const {
  useBetEvent
} = svs.components.sportinfo.matchInfoHooks;
const {
  clx
} = svs.components.lbUtils;
const {
  useBranding,
  useGetSelectedEventNumber,
  useIsTipsinfoEnabled
} = svs.components.tipsen.hooks;
const {
  baseUrl
} = svs.core.data;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  DescriptionSize
} = svs.components.lbUi.participants.constants;
const {
  TipsinfoTypes
} = svs.components.tipsen.engine.constants;
const {
  DistributionDisplay,
  ButtonBet,
  TeamNames,
  Checkmark,
  EventNumber,
  EventComment,
  Init
} = svs.components.tipsen.couponStatic;
const {
  TipsenLink
} = svs.components.tipsen.tipsen_link;
const {
  buttonChoices,
  getOutcomeLabelsForEventType
} = svs.components.sport.tipsenShared;
const {
  STATISTIC_SIDEBAR_QUERY
} = svs.components.tipsen.constants;
const {
  useDrawSearchParams
} = svs.components.tipsen.drawProvider.hooks;
const {
  Tipsinfo
} = svs.components.tipsen.tipsinfo;
const {
  selectOutcomeInfoChoise
} = svs.components.tipsen.selectors;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  getIsDistributionDisplay,
  getProductDistribution,
  getShouldShowCheckmark,
  getShouldShowInit,
  getShouldShowTeamNames
} = svs.components.tipsen.couponStatic.utils;
const {
  CorrectResult
} = svs.components.tipsen.couponStatic;
const {
  RenderContext
} = svs.component.tipsen.renderContext;
const {
  getAriaLabelForEvent,
  getOutcomeAriaLabel1X2
} = svs.components.poolBetting.ariaUtils;
const {
  selectParticipant
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  selectSportEvent
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  getIsOngoing
} = svs.components.sportinfo.common.matchState;
const {
  composeResultUpdateText
} = svs.components.poolBetting.ariaUtils;
const createCouponRowHref = () => {
  const href = location.pathname.replace(baseUrl, '');
  return href;
};
const getEventClassName = _ref => {
  let {
    isGoalCount,
    isSelected,
    mSign
  } = _ref;
  const mainClassName = 'pg_coupon_static__event';
  return clx(mainClassName, {
    ["".concat(mainClassName, "--selected")]: isSelected,
    ["".concat(mainClassName, "--goal_count")]: isGoalCount,
    ["".concat(mainClassName, "--m_sign")]: mSign
  });
};
const defaultClassList = ['pg_coupon_static__event_container'];
const animationFadeOut = 'fadeOutAnimation';
const CouponStaticRow = _ref2 => {
  var _useSelector, _productDistribution$, _productDistribution$2, _productDistribution$3, _betButtons$drawResul;
  let {
    alwaysIncludeParams,
    drawCompetitionId,
    drawEvent,
    drawResult,
    drawState,
    playerBet = [],
    sportType,
    drawNumber,
    productId,
    nameSize = DescriptionSize.Full,
    isCompressed = false,
    distributionChoice = [],
    selectedCouponChoice = buttonChoices.GAMES,
    systemType,
    bestBetRowResult,
    mSign,
    uSign,
    hasChangedResult,
    betProperties = [],
    distributionForRow
  } = _ref2;
  const {
    isResult,
    pageType
  } = useContext(RenderContext);
  const drawId = ''.concat(productId, '_').concat(drawNumber);
  const betButtons = getOutcomeLabelsForEventType(drawEvent.eventTypeId, sportType);
  const isGoalCount = drawEvent.eventTypeId === EventTypeId.GOAL_COUNT;
  const isHead2Head = drawEvent.eventTypeId === EventTypeId.HEAD_TO_HEAD;
  const selectedEventNumber = useGetSelectedEventNumber();
  const isSelected = drawEvent.eventNumber === selectedEventNumber;
  const branding = useBranding(drawId, drawCompetitionId);
  const [productBanding] = branding;
  const outcomeInfoChoice = (_useSelector = useSelector(state => selectOutcomeInfoChoise(state, pageType))) === null || _useSelector === void 0 ? void 0 : _useSelector.display;
  const toParams = useDrawSearchParams(productId, drawNumber, drawEvent.eventNumber, alwaysIncludeParams);
  const searchParams = new URLSearchParams(toParams);
  const showCouponAndDetailView = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  const sportEvent = useSelector(state => selectSportEvent(state, drawEvent.matchId));
  const isOngoing = sportEvent ? getIsOngoing(sportEvent.sportEventStatus) : undefined;
  if (!showCouponAndDetailView) {
    searchParams.set('openStatistic', '');
  }
  const {
    eventStatistics,
    betEvent
  } = useBetEvent({
    productId,
    drawNumber,
    eventNumber: drawEvent.eventNumber
  });
  const homeParticipant = useSelector(state => {
    var _betEvent$participant;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant = betEvent.participants) === null || _betEvent$participant === void 0 ? void 0 : _betEvent$participant[0]);
  });
  const awayParticipant = useSelector(state => {
    var _betEvent$participant2;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant2 = betEvent.participants) === null || _betEvent$participant2 === void 0 ? void 0 : _betEvent$participant2[1]);
  });
  const productDistribution = getProductDistribution({
    eventStatistics,
    productId,
    drawNumber
  });
  const displayProductDistributionValue = (productDistribution === null || productDistribution === void 0 || (_productDistribution$ = productDistribution.current) === null || _productDistribution$ === void 0 ? void 0 : _productDistribution$.value[0]) && (productDistribution === null || productDistribution === void 0 || (_productDistribution$2 = productDistribution.current) === null || _productDistribution$2 === void 0 ? void 0 : _productDistribution$2.value[1]) && (productDistribution === null || productDistribution === void 0 || (_productDistribution$3 = productDistribution.current) === null || _productDistribution$3 === void 0 ? void 0 : _productDistribution$3.value[2]);
  const betButtonsToShow = useMemo(() => {
    if (outcomeInfoChoice === TipsinfoTypes.SvenskaFolket && displayProductDistributionValue && !isCompressed) {
      return productDistribution.current.value.map((result, index) => _objectSpread(_objectSpread({}, result), {}, {
        resultIndex: index,
        resultText: {
          text: "".concat(result, "%")
        },
        ariaLabel: getOutcomeAriaLabel1X2({
          eventTypeId: drawEvent.eventTypeId,
          postfixSymbol: '%',
          svenskaFolketValue: result,
          sign: betButtons[index].sign,
          homeParticipant,
          awayParticipant
        })
      }));
    }
    const buttonsToReturn = betButtons.map(btn => _objectSpread(_objectSpread({}, btn), {}, {
      resultIndex: betButtons.indexOf(btn),
      resultText: btn,
      ariaLabel: getOutcomeAriaLabel1X2({
        eventTypeId: drawEvent.eventTypeId,
        sign: btn.sign,
        homeParticipant,
        awayParticipant
      })
    }));
    if (isCompressed) {
      return buttonsToReturn.filter(button => button.resultIndex === (drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome[0][0]));
    }
    return buttonsToReturn;
  }, [outcomeInfoChoice, displayProductDistributionValue, isCompressed, betButtons, productDistribution, drawEvent.eventTypeId, homeParticipant, awayParticipant, drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome]);
  const {
    isAnyTipsinfoEnabled
  } = useIsTipsinfoEnabled();
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const [classList, setClassList] = useState(defaultClassList);
  useEffect(() => {
    if (hasChangedResult) {
      setClassList([...defaultClassList, 'pg_coupon_static__event_container--changed_result']);
    }
  }, [hasChangedResult]);
  useEffect(() => {
    if (branding.length > 1) {
      setClassList([...classList, branding[branding.length - 1]]);
    }
  }, [branding, classList]);
  const handleAnimationEnd = useCallback(event => {
    if (event.animationName === animationFadeOut) {
      setClassList(defaultClassList);
    }
  }, []);
  const getButtonBetClassNames = () => {
    const classNames = ['pg_coupon_static__bet_buttons'];
    if (branding && branding.length > 0) {
      classNames.push("pg_coupon_static__bet_buttons--".concat(branding.join(' ')));
    }
    return classNames.join(' ');
  };
  return React.createElement("li", {
    className: classList.join(' '),
    onAnimationEnd: handleAnimationEnd
  }, React.createElement(TipsenLink, _extends({
    "aria-label": getAriaLabelForEvent({
      eventTypeId: betEvent.eventTypeId,
      homeParticipant,
      awayParticipant
    }),
    className: getEventClassName({
      isGoalCount,
      isSelected,
      mSign
    }),
    disabled: isHead2Head || isSelected && showCouponAndDetailView 
    ,
    to: {
      pathname: createCouponRowHref(),
      search: "?".concat(searchParams)
    }
  }, isSelected ? {
    'aria-current': 'page'
  } : {}), React.createElement("div", {
    className: "pg_coupon_static__event_number"
  }, React.createElement(EventNumber, {
    bestBetRowResult: bestBetRowResult,
    branding: productBanding,
    drawResult: drawResult,
    eventNumber: drawEvent.eventNumber,
    eventTypeId: drawEvent.eventTypeId,
    isCompressed: isCompressed,
    userRow: playerBet
  })), getShouldShowTeamNames({
    selectedCouponChoice,
    isCompressed
  }) && React.createElement("div", {
    className: "pg_coupon_static__event_desc f-medium ".concat(isGoalCount ? 'fc-fulltraff-400' : '')
  }, React.createElement(TeamNames, {
    drawEventNumber: drawEvent.eventNumber,
    drawNumber: drawNumber,
    nameSize: nameSize,
    productId: productId,
    subDescription: isHead2Head ? 'Vem gör flest mål?' : null
  })), getIsDistributionDisplay(selectedCouponChoice) && isCompressed && React.createElement(DistributionDisplay, {
    distributionChoice: distributionChoice,
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    productId: productId,
    selectedCouponChoice: selectedCouponChoice
  }), getShouldShowCheckmark({
    systemType,
    isResult,
    isGoalCount,
    isCompressed
  }) && React.createElement(Checkmark, {
    drawResult: drawResult,
    isGoalCount: isGoalCount,
    isResult: isResult,
    systemType: systemType,
    userRow: playerBet
  }), getShouldShowInit({
    isGoalCount,
    isCompressed,
    selectedCouponChoice,
    isSmall
  }) && React.createElement(Init, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    drawState: drawState,
    eventNumber: drawEvent.eventNumber,
    isCompressed: isCompressed,
    isResultPage: isResult,
    productId: productId,
    selectedCouponChoice: selectedCouponChoice
  }), !isCompressed && mSign && React.createElement("span", {
    className: "pg_coupon_static__m_sign"
  }, "M"), !isCompressed && React.createElement("div", {
    className: getButtonBetClassNames()
  }, betButtonsToShow.map((result, index) => React.createElement(ButtonBet, {
    betProperties: betProperties,
    branding: productBanding,
    distribution: distributionForRow === null || distributionForRow === void 0 ? void 0 : distributionForRow[index],
    isCorrect: result.resultIndex === (drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome[0][0]) 
    ,
    isSelected: playerBet.includes(result.resultIndex) 
    ,
    key: result.text,
    result: result,
    uSign: uSign === index
  }))), isCompressed && React.createElement(CorrectResult, {
    betButtonsToShow: betButtonsToShow
  }), !isCompressed && React.createElement(EventComment, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    drawResult: drawResult,
    drawState: drawState,
    productId: productId
  }), !isCompressed && isAnyTipsinfoEnabled && React.createElement("div", {
    className: "pg_coupon_static__tipsinfo"
  }, React.createElement(Tipsinfo, {
    drawId: drawId,
    drawNumber: drawNumber,
    eventNumber: drawEvent.eventNumber,
    outcomeInfoChoisesStateDisplay: outcomeInfoChoice,
    outcomeLabels: betButtons,
    productId: productId
  }))), isOngoing && drawResult && React.createElement("span", {
    "aria-live": "polite",
    className: "sr-only"
  }, composeResultUpdateText({
    eventTypeId: drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventTypeId,
    eventNumber: drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventNumber,
    eventDescription: drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventDescription,
    numberOfGoalsHomeTeam: drawResult === null || drawResult === void 0 ? void 0 : drawResult.home,
    numberOfGoalsAwayTeam: drawResult === null || drawResult === void 0 ? void 0 : drawResult.away,
    outcome: (_betButtons$drawResul = betButtons[drawResult === null || drawResult === void 0 ? void 0 : drawResult.outcome[0]]) === null || _betButtons$drawResul === void 0 ? void 0 : _betButtons$drawResul.sign
  })));
};
setGlobal('svs.components.tipsen.couponStatic.CouponStaticRow', CouponStaticRow);

 })(window);